import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import InstitucionesPage from "./pages/public/InstitucionesPage";
import LoginPage from "./pages/login/LoginPage";
import HomePage from "./pages/public/HomePage";
import ProtectedRoute from "./services/ProtectedRoute";
import InstitucionesTablePage from "./pages/dashboard/instituciones/InstitucionesTablePage";
import AdminAddPage from "./pages/dashboard/administradores/AdminAddPage";
import DashboardRoutes from "./pages/dashboard/DashboardRoutes";
import InstitucionAddPage from "./pages/dashboard/instituciones/InstitucionAddPage";
import CarrerasTablePage from "./pages/dashboard/carreras/CarrerasTablePage";
import CarreraAddPage from "./pages/dashboard/carreras/CarreraAddPage";
import EventoAddPage from "./pages/dashboard/eventos/EventoAddPage";
import EventoEditPage from "./pages/dashboard/eventos/EventoEditPage";
import EventosTablePage from "./pages/dashboard/eventos/EventosTablePage";
import NoticiasTablePage from "./pages/dashboard/noticias/NoticiasTablePage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import CarrerasPage from "./pages/public/CarrerasPage";
import CarreraPage from "./pages/public/CarreraPage";
import NoticiasPage from "./pages/public/NoticiasPage"
import NoticiaPage from "./pages/public/NoticiaPage";
import EventosPage from "./pages/public/EventosPage";
import EventoDetailPage from "./pages/public/EventoDetailPage";
// import CarreraEditPage from "./pages/dashboard/carreras/CarreraEditPage";
// import InstitucionEditPage from "./pages/dashboard/instituciones/InstitucionEditPage";
// import AdminEditPage from "./pages/dashboard/administradores/AdminEditPage";
import AdminsTablePage from "./pages/dashboard/administradores/AdminsTablePage";
import { APIProvider } from "@vis.gl/react-google-maps";
import config from "./MapConfig";
import ServerErrorPage from "./pages/ServerErrorPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import NavbarWrapper from "./components/NavbarWrapper";
import FooterComponent from "./components/FooterComponent";
import InstitucionPage from "./pages/public/InstitucionPage";
import NotFoundPage from "./pages/NotFoundPage";
import BadRequestPage from "./pages/BadRequestPage";
import MisionerosCanibalesPage from "./pages/public/JuegoPage";
import TomaDecisionPage from "./pages/public/TomaDecisionPage";
import theme from "./theme";
import NoticiasAddPage from "./pages/dashboard/noticias/NoticiasAddPage";
import NoticiasEditPage from "./pages/dashboard/noticias/NoticiasEditPage";


// TODO: GENERAL: 1- Mapas; 2- Ordenar x prioridad carreras ✅; 3- Manejo de errores (no mostrar msj feos) 🔛; 4- SACAR DECODED TOKEN, NO HACE FALTA NO? DESDE EL BACK TOKEN EXPIRADO Y ESO

function App() {
  return (
  <ChakraProvider theme={theme}>
      <APIProvider apiKey={config.API_MAPS_KEY} language="es">
        <BrowserRouter>
          <NavbarWrapper />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/carreras" element={<CarrerasPage />} />
            <Route path="/carreras/:id" element={<CarreraPage />} />
            <Route path="/eventos" element={<EventosPage />} />
            <Route path="/eventos/:id" element={<EventoDetailPage />} />
            <Route path="/instituciones/:id" element={<InstitucionPage />} />
            <Route path="/instituciones" element={<InstitucionesPage />} />
            <Route path="/noticias" element={<NoticiasPage />} />
            <Route path="/noticias/:id" element={<NoticiaPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path="/servererror" element={<ServerErrorPage />} />
            <Route path="/info" element={<MisionerosCanibalesPage />} />
            <Route path="/decision" element={<TomaDecisionPage />} />

            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute roles={[1, 2]}>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />

            <Route path="/dashboard/*" element={<DashboardRoutes />} />

            <Route
              path="/dashboard/instituciones"
              element={
                <ProtectedRoute roles={[1]}>
                  <InstitucionesTablePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/instituciones-crear"
              element={
                <ProtectedRoute roles={[1]}>
                  <InstitucionAddPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/instituciones-editar/:id"
              element={
                <ProtectedRoute roles={[1]}>
                  <InstitucionAddPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/administradores"
              element={
                <ProtectedRoute roles={[1]}>
                  <AdminsTablePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/usuarios-crear"
              element={
                <ProtectedRoute roles={[1]}>
                  <AdminAddPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/usuarios-editar/:id"
              element={
                <ProtectedRoute roles={[1]}>
                  <AdminAddPage />
                </ProtectedRoute>
              }
            />
       <Route
              path="/dashboard/noticias"
              element={
                <ProtectedRoute roles={[1]}>
                  <NoticiasTablePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/noticias-crear"
              element={
                <ProtectedRoute roles={[1]}>
                  <NoticiasAddPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/noticias-editar/:id"
              element={
                <ProtectedRoute roles={[1]}>
                  <NoticiasEditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/carreras"
              element={
                <ProtectedRoute roles={[2]}>
                  <CarrerasTablePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/carreras-crear"
              element={
                <ProtectedRoute roles={[2]}>
                  <CarreraAddPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/carreras-editar/:id"
              element={
                <ProtectedRoute roles={[2]}>
                  <CarreraAddPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/eventos-crear"
              element={
                <ProtectedRoute roles={[1, 2]}>
                  <EventoAddPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/eventos-editar/:id"
              element={
                <ProtectedRoute roles={[1, 2]}>
                  <EventoEditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/eventos"
              element={
                <ProtectedRoute roles={[1, 2]}>
                  <EventosTablePage />
                </ProtectedRoute>
              }
            />
            <Route path="/badrequest" element={<BadRequestPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <FooterComponent />
        </BrowserRouter>
      </APIProvider>
    </ChakraProvider>
  );
}

export default App;
